import { createSlice } from "@reduxjs/toolkit"
import { status_slices } from "../../Constants";
import { setCatalog } from "../catalogs/slice";


export const products = createSlice({
    name: 'products',
    initialState: {
        isLoading: true,
        status: status_slices.SUCCESS,
        msg: '',
        indicatorsProducts: [],
        listSuppliers: [],
        listBrands: [],
        listCategories: [],
        catalogProduct: [],
        detailProduct: [],
        historyProduct: [],

    },
    reducers: {
        clearProductsMemory: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.catalogProduct = [];
        },
        clearEditProductMemory: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.detailProduct = [];
            state.historyProduct = [];
        },
        clearListCatalogs: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.listBrands = [];
            state.listSuppliers = [];
            state.listCategories = [];
        },
        setListCatalogs: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Catalogos para registro/actualizacion cargado';
            state.listBrands = action.payload.listBrands;
            state.listSuppliers = action.payload.listSuppliers;
            state.listCategories = action.payload.listCategories;
        },
        setIndicatorsProducts: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Indicadores de los productos cargados';
            state.indicatorsProducts = action.payload.indicators;
        },
        setCatalogProduct: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Listado de productos cargado';
            state.catalogProduct = action.payload.catalog;
        },
        setEditProduct: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Detalle ';
            state.detailProduct = action.payload.detail;
            state.historyProduct = action.payload.history;
        },
        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = "";
        },
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        }
    }
});

export const { processRequest, notProcessRequest, setError, clearProductsMemory, clearEditProductMemory, clearListCatalogs, setCatalogProduct, setEditProduct, setIndicatorsProducts, setListCatalogs } = products.actions;